import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { computePermissions } from "../utils/permission";
import { findMemberByUserId } from "../utils/member-lookup";

const usePermissions = () => {
    const { id } = useParams()
    const auth = useSelector(state => state.auth)
    const members = useSelector(state => state.members)
    // Find the selected patient based on members list and URL ID
    const selectedPatient = useMemo(
        () => findMemberByUserId(members, id),
        [members, id]
    );

    // Compute view permissions
    const myViewPermissions = useMemo(() => {
        return computePermissions({
            roles: auth?.roles,
            authId: auth?.id,
            assignedStaff: selectedPatient?.user?.assignedStaff,
        });
    }, [auth, selectedPatient]);

    return {
        myPermissions: myViewPermissions,
        isAdministrator: auth?.roles?.includes("ADMINISTRATOR"),
        isStaffPhysician: auth?.roles?.includes("STAFF_PHYSICIAN"),
    };
};

export default usePermissions;
